import { useGetList } from 'ra-core';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useStructureCourante } from '../fournisseurs/structure-courante';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * **LE SÉLECTEUR PERMANENT DE F-55, ET IL N'APPARAÎT QUE POUR UN SEUL RÔLE.**
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * F-55 : « **le passage d'une structure à l'autre est un sélecteur permanent en tête de la
 * surface**, listant toutes les structures. » Et, deux lignes plus bas : « **la personne qui
 * tient un espace n'a pas de sélecteur**, portant au plus un rattachement : **il n'aurait
 * qu'une ligne**. »
 *
 * Ce n'est donc pas un sélecteur qu'on désactive pour un `orgadmin` : **il n'existe pas pour
 * lui**. Un sélecteur grisé à une ligne dirait qu'il y a un choix ailleurs, ce que la
 * matrice ferme.
 *
 * **Aucun chiffre n'apparaît à côté.** F-55 : « **aucun tableau de bord, aucun chiffre en
 * tête de surface.** Les chiffres vivent à leur écran. »
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **CE QU'IL COÛTE DE LE LAISSER VIDE, ET POURQUOI ON LE DIT.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * F-55 critère 2 : « QUAND le compte qui voit tout ouvre un écran de structure **sans
 * structure courante**, LE SYSTÈME DOIT **exiger la sélection d'une structure** au lieu de
 * rendre une liste du parc. » Le fournisseur de données lève dans ce cas, avec ce que la
 * personne doit faire — et c'est ici qu'elle le fait.
 *
 * **La liste n'est pas paginée, et c'est assumé.** Le sélecteur demande la première tranche,
 * cent structures au plus, borne du contrat. Au-delà, la liste des structures est l'écran
 * d'arrivée et porte sa recherche : un sélecteur de six cents lignes ne se parcourt pas de
 * toute façon.
 */
export function SelecteurDeStructure() {
  const { structureId, selecteurAffiche, choisir } = useStructureCourante();
  const { data, isPending } = useGetList(
    'structures',
    { pagination: { page: 1, perPage: 100 } },
    { enabled: selecteurAffiche },
  );

  if (!selecteurAffiche) return null;

  return (
    <Select value={structureId ?? undefined} onValueChange={choisir}>
      <SelectTrigger className="w-[280px]" aria-label="Structure de travail">
        <SelectValue
          placeholder={isPending ? 'Chargement des structures…' : 'Choisir une structure'}
        />
      </SelectTrigger>
      <SelectContent>
        {(data ?? []).map((structure: { id: string; nomInterne: string }) => (
          <SelectItem key={structure.id} value={structure.id}>
            {structure.nomInterne}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
